import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { UserProfile } from "../../core/model/user-profile";
import { PermissionSelectedDTO } from "../../core/model/permission-selected-dto";
import { PermissionService } from "../../core/service/permission.service";
import { UserProfileService } from "../../core/service/user-profile.service";
import { AssocierPermissionAuProfile } from "../../core/model/associer-permission-au-profile";

@Component({
  selector: "app-permission-by-profile",
  templateUrl: "./permission-by-profile.component.html",
  styleUrls: ["./permission-by-profile.component.scss"],
})
export class PermissionByProfileComponent implements OnInit {
  profileId: string;
  userProfile: UserProfile;

  permissionSelectedDTOs: PermissionSelectedDTO[];

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
    private _userProfileService: UserProfileService,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.profileId = params["profileId"];
      this.getUserProfile(this.profileId);
      this.getPermissions(this.profileId);
    });
  }

  getUserProfile(profileId) {
    this._userProfileService.getUserProfileById(profileId).subscribe(
      (data) => {
        this.userProfile = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getPermissions(profileId) {
    this._permissionService.findSelectedPermissions(profileId).subscribe(
      (data) => {
        this.permissionSelectedDTOs = data.sort((a, b) =>
          a.code > b.code ? 1 : -1
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeAfterChecked(values: any, permissionId) {
    var input = new AssocierPermissionAuProfile();
    input.permissionId = permissionId;
    input.profileId = this.profileId;
    input.selected = values.currentTarget.checked;
    this.associer(input);
  }

  associer(associerPermissionAuProfile: AssocierPermissionAuProfile) {
    this._permissionService.associer(associerPermissionAuProfile).subscribe(
      (data) => {
        this.getPermissions(this.profileId);
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );
  }

  cancel(): void {
    this._router.navigate(["/parametrage/user-profile"]);
  }
}
